import React from 'react';
import PropTypes from 'prop-types';
import { Attribute, Label, Value } from './Styles';

const BoxSubAttribute = ({ label, value }) => {
  return (
    <Attribute>
      <Label>{label}</Label>
      <Value>{value}</Value>
    </Attribute>
  );
};

BoxSubAttribute.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
};

export default BoxSubAttribute;
